module.exports = __webpack_public_path__ + "static/img/footer_logo.77de4ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_logo.png
// module id = t0Qz
// module chunks = 32